import isNull from 'lodash/isNull'
import type { UtilStoreHeaderType } from '~/types'

export const useUtilsStore = defineStore('utils', () => {
  const { hasPaymentKeys } = storeToRefs(useAuthStore())

  const sidebar = ref<{ open: boolean }>({ open: true })
  const header = ref<UtilStoreHeaderType>({
    title: 'Dashboard',
  })

  const isAddPaymentProviderOpen = ref<boolean>(false)

  const isOpen = $computed<boolean>(() => sidebar.value.open === true)

  function sidebarToggle(value: boolean | null = null): void {
    sidebar.value.open = isNull(value) ? !sidebar.value.open : value
  }

  function closeSidebar(): void {
    if (sidebar.value.open) {
      sidebar.value.open = false
    }
  }

  function updateHeader(_value: typeof header.value) {
    header.value = { ..._value }
  }

  function openAddPaymentProvider(): void {
    isAddPaymentProviderOpen.value = true
  }

  function closeAddPaymentProvider(): void {
    isAddPaymentProviderOpen.value = false
  }

  async function openProviderIfKeysNotAdded(): Promise<true | undefined> {
    await nextTick()

    if (!hasPaymentKeys.value && !isAddPaymentProviderOpen.value) {
      openAddPaymentProvider()
      return true
    }
  }

  return {
    sidebarToggle,
    closeSidebar,
    isOpen,
    sidebar,
    updateHeader,
    header,
    isAddPaymentProviderOpen,
    openAddPaymentProvider,
    closeAddPaymentProvider,
    openProviderIfKeysNotAdded,
  }
})
